// 站内 SPA 跳转（避免整页刷新导致播放器中断）
// 用法：spaNavigate('/cn/music/2.html')
export function spaNavigate(path) {
  if (typeof window === 'undefined') return;
  if (path === -1) {
    window.history.back();
    return;
  }
  const next = String(path || '');
  if (!next) return;
  try {
    window.history.pushState({}, '', next);
    window.dispatchEvent(new Event('app:navigate'));
    // 默认行为：新页面从顶部开始（避免“从列表滚动位置进入详情页，顶部内容看不到”）
    // 注意：history.back() 的滚动恢复由浏览器处理（上面已 return）。
    // 若未来有少数场景需要保留滚动，可在 next 中自行加 hash 并在此处加白名单。
    try {
      window.requestAnimationFrame(() => {
        try {
          window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
        } catch (_) {
          window.scrollTo(0, 0);
        }
      });
    } catch (_) {}
  } catch (_) {
    // 兜底：极少数环境下退回硬跳转
    window.location.href = next;
  }
}


